import React, { useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import PercentageNumber from "../../../../components/UI/PercentageNumber";
import Typography from "@material-ui/core/Typography";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

import { sortFeeSchedules } from "../TieredFeeDataBox/helper";
import { BaseTooltip } from "../../../../components/BaseComponents";
import { AppTheme } from "../../../../theme";
import { isPremiumView } from "../../../../utilities/access";

const seekRate = (breakpoints, value) => {
  
  // It is easy to seek correct fee calculation if we check lower and higher bounds for fee schedule
  // so this loop will just do a comparison.
  // If there is a null breakpoint or no breakpoint to compare our very high
  // portfolio amount, we will compare it with infinity.

  const sortedFeeSchedules = sortFeeSchedules(breakpoints);
  let rate = 0;

  for (let i = 0; i < sortedFeeSchedules.length; i++) {
    const min = sortedFeeSchedules[i].breakpoint;
    const max = sortedFeeSchedules[i + 1] ?
      (
        sortedFeeSchedules[i + 1].breakpoint ?
          sortedFeeSchedules[i + 1].breakpoint :
          Infinity
      ) :
      Infinity;

    if ( value > min && value <= max ) {
      rate = Number(sortedFeeSchedules[i].rate || 0);
      break;
    }
  }

  return rate;
};

const PortfolioFeeSummary = (props) => {
  const {
    appName,
    custodians,
    onboardedCustodianId,
    portfolioInvestment,
    cyPlatformFees,
    userPlatformFees,
    userCustodianFees,
    portfolioAdvisorFee,
    forPrinting,
    accessLevel,
  } = props;
  const [custodianId, setCustodianId] = useState(
    onboardedCustodianId || Number(Object.keys(userCustodianFees)[0])
  );
  const changeCustodianId = (e) => {
    setCustodianId(Number(e.target.value));
  };

  const advisorFee = Number(portfolioAdvisorFee);

  const platformFeeInUsage = userPlatformFees.length > 0 ?
    userPlatformFees:
    cyPlatformFees;

  const platformFee = seekRate(platformFeeInUsage, portfolioInvestment);

  const custodianFee = seekRate(userCustodianFees[custodianId], portfolioInvestment);

  return (
    <React.Fragment>
      {!forPrinting && (
        <Typography
          variant="subtitle1"
          style={{ margin: "30px 0 10px", fontWeight: 500 }}
        >
          Fee Summary
        </Typography>
      )}
      <Table size={"small"}>
        <TableBody>
          {/*<TableRow hover={true}>*/}
          {/*  <TableCell><Typography variant="body1">Total Manager Fee</Typography></TableCell>*/}
          {/*  <TableCell align="right" style={{minWidth: 100}}>*/}
          {/*    <Typography variant="body1" color="primary"><PercentageNumber value={managerFee} needCalculation={false} /></Typography>*/}
          {/*  </TableCell>*/}
          {/*</TableRow>*/}
          <TableRow hover={true}>
            <TableCell>
              <Typography variant="body1">Total Advisor Fee</Typography>
            </TableCell>
            <TableCell align="right" style={{ minWidth: 100 }}>
              <Typography variant="body1" color="primary">
                <PercentageNumber value={advisorFee} needCalculation={false} />
              </Typography>
            </TableCell>
          </TableRow>
          {isPremiumView(accessLevel) && (
            <React.Fragment>
              <TableRow hover={true}>
                <TableCell>
                  <Typography variant="body1">Total Platform Fee</Typography>
                </TableCell>
                <TableCell align="right" style={{ minWidth: 100 }}>
                  <Typography variant="body1" color="primary">
                    <PercentageNumber value={platformFee} needCalculation={false} />
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow hover={true}>
                <TableCell>
                  <BaseTooltip
                    labelComponent={
                      appName === 'American Portfolios' ?
                      <Typography variant="body1">
                        Total Program Fee
                      </Typography> :
                      <Typography variant="body1">
                        Total Custodial Fee
                      </Typography>
                    }
                    helperText="All custodian fees you have configured are displayed here."
                    showTooltip={!onboardedCustodianId && !forPrinting}
                    boxProps={{mb: 1}}
                  />
                  {!onboardedCustodianId && custodians.length > 1 && (
                    <RadioGroup
                      row
                      value={custodianId}
                      onChange={changeCustodianId}
                    >
                      {Object.keys(userCustodianFees).map((custodianId) => {
                        const custodian = custodians.find(
                          (c) => c.id === Number(custodianId)
                        );
                        return (
                          <FormControlLabel
                            key={custodianId}
                            value={Number(custodianId)}
                            control={<Radio size={"small"} color={"primary"} />}
                            label={custodian.name}
                          />
                        );
                      })}
                    </RadioGroup>
                  )}
                  {
                    (onboardedCustodianId || custodians.length === 1) &&
                    Object.keys(userCustodianFees).map((custodianId) => {
                      const custodian = custodians.find(
                        (c) => c.id === Number(custodianId)
                      );
                      return (
                        custodian && onboardedCustodianId === custodian.id &&
                        <Typography variant="body1" key={custodianId}>
                          ({custodian.name})
                        </Typography>
                      );
                    })
                  }
                </TableCell>
                <TableCell align="right" style={{ minWidth: 100 }}>
                  <Typography variant="body1" color="primary">
                    <PercentageNumber
                      value={custodianFee}
                      needCalculation={false}
                    />
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow
                hover={true}
                style={
                  forPrinting ? { background: AppTheme.palette.grey[200] } : {}
                }
              >
                <TableCell>
                  <Typography variant="body1">TOTAL FEE</Typography>
                </TableCell>
                <TableCell align="right" style={{ minWidth: 100 }}>
                  <Typography variant="body1" color="primary">
                    <PercentageNumber
                      value={advisorFee + platformFee + custodianFee}
                      needCalculation={false}
                    />
                  </Typography>
                </TableCell>
              </TableRow>
            </React.Fragment>
          )}
        </TableBody>
      </Table>
      <Typography
        className={"disclosure"}
        variant={"caption"}
        paragraph
        style={{ marginTop: 16 }}
      >
        Note: These fees are not included in the Cy Optimized Portfolio
        net of fee expense returns.
      </Typography>
    </React.Fragment>
  );
};

export default PortfolioFeeSummary;



// WEBPACK FOOTER //
// ./src/containers/Cy/components/PortfolioFeeSummary/index.jsx